import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import './Units.scss'
import {getIdleUnits, getPercent, getTypeUnits, getUnitsGrouped, updateBudget} from "./integracion";
import StatusCard from "../../../components/molecules/StatusCard/StatusCard";
import { MultiSelect } from 'primereact/multiselect';
import { Accordion, AccordionTab } from "primereact/accordion";
import {Button} from "primereact/button";
import map from '../../../assets/icons/google_map.svg';
import refresh from "../../../assets/icons/refresh.svg";
import Swal from "sweetalert2";
import Loader from "../../../components/molecules/Loader/Loader";


const Units = () => {
    const [loading, setLoading] = useState(false);
    const [units, setUnits] = useState([]);
    const [typeUnits, setTypeUnits] = useState([]);
    const [percent, setPercent] = useState([]);
    const [expandedRows, setExpandedRows] = useState(null);
    const [idleUnits, setIdleUnits] = useState([]);
    const [selectedTypes, setSelectedTypes] = useState([]);
    const vehicleTypes = [
        { key: "CAMION GRANDE", label: "Camion grande" },
        { key: "CAMION CHICO", label: "Camion chico" },
        { key: "CAMIONETA", label: "Camioneta" },
        { key: "AUTOBUS", label: "Autobus" },
        { key: "AUTOMOVIL", label: "Automovil" },
        { key: "MINIVAN", label: "Minivan" },
        { key: "SPRINTER", label: "Sprinter" },
        { key: "CAMION GRANDE A/A", label: "Camion grande A/A" },
        { key: "CAMION CHICO A/A", label: "Camion chico A/A" }
    ];


    useEffect(() => {
        setLoading(true);

        const fetchData = async () => {
            try {
                await Promise.all([
                    new Promise(resolve => getUnitsGrouped(data => {
                        setUnits(data);
                        resolve();
                    })),
                    new Promise(resolve => getTypeUnits(data => {
                        setTypeUnits(data);
                        resolve();
                    })),
                    new Promise(resolve => getPercent(data => {
                        setPercent(data);
                        resolve();
                    })),
                    new Promise(resolve => getIdleUnits(data => {
                        setIdleUnits(data);
                        resolve();
                    }))
                ]);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        if (!selectedTypes || selectedTypes.length === 0) return;

        setLoading(true);

        const ids = selectedTypes.map(item => item.code);

        const fetchData = async () => {
            try {
                await Promise.all([
                    new Promise(resolve => getUnitsGrouped(data => {
                        setUnits(data);
                        resolve();
                    }, ids)),
                    new Promise(resolve => getPercent(data => {
                        setPercent(data);
                        resolve();
                    }, ids)),
                    new Promise(resolve => getIdleUnits(data => {
                        setIdleUnits(data);
                        resolve();
                    }, ids))
                ]);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [selectedTypes]);

    const handleEdit = (id, budget) => {
        updateBudget(id, budget).then(()=> {
            const ids = [];
            selectedTypes?.map((item) => {
                ids.push(item.code);
            })
            getPercent(setPercent, ids);
        })
    };

    const showMap = (data) => {
        if (data && data.POSITION?.lat && data.POSITION?.lng) {
            const { lat, lng } = data.POSITION;
            const googleMapsUrl = `https://www.google.com/maps?q=${lat},${lng}`;
            window.open(googleMapsUrl, '_blank');
        } else {
            Swal.fire({
                icon: "error",
                text: 'Coordenadas inválidas',

            });
        }
    };

    const actionBodyTemplate = (data) => {
        return <Button icon={<img src={map} alt="list" width="20px" />}
                       rounded text onClick={()=>{showMap(data)}}></Button>
    };

    const rowExpansionTemplate = (data) => {
        return (
            <DataTable className="expansion" value={data.units}>
                <Column field="ID" header="ID" sortable/>
                <Column field="DESCRIPCION" header="Descripción" sortable/>
                <Column field="TIPO" header="Tipo" sortable/>
                <Column field="MODELO" header="Modelo" sortable/>
                <Column field="ESTATUS" header="Estatus" sortable/>
                <Column field="POSITION.ti" header="Última actualización" sortable/>
                <Column headerStyle={{ width: '5rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} body={actionBodyTemplate} />
            </DataTable>
        );
    };

    const headerTemplate = (data) => {
        return (
            <React.Fragment>
                <div className="header-types">
                    <span>{data.nombre} ({data.count})</span>
                </div>
            </React.Fragment>
        );
    };

    const headerDetail = (data) => {
        return (
            <span className="span-types">
            {vehicleTypes.map(({key, label}) =>
                data.typeCounts[key] ? `${label}: ${data.typeCounts[key]} ` : ''
            ).join(' ')}
        </span>
        )
    }


    return (
        <div className="units">
            {loading && <Loader />}
            <MultiSelect
                className="type-multiselect"
                value={selectedTypes}
                onChange={(e) => setSelectedTypes(e.value)}
                options={typeUnits}
                optionLabel="name"
                maxSelectedLabels={3}
                placeholder="Selecciona el tipo de unidad"
            />
            <div className="status-cards-container">
                <div className="grid">
                    {percent.map((item, index) => (
                        <div key={index} className="col-12 sm:col-6 md:col-4 lg:col-3 xl:col-2">
                            <StatusCard
                                rend={item.PRESUPUESTO}
                                title={item.ESTATUS}
                                amount={item.UNIDADES}
                                change={item.PORCENTAJE}
                                isPositive={item.isPositive}
                                id={item.ID_STATUS}
                                onBudgetUpdate={handleEdit}
                            />
                        </div>
                    ))}
                </div>
            </div>
            <div className="idle-units">
                <div className="idle-units-table-container">
                    <Accordion activeIndex={0} className={'table-padding'}>
                        <AccordionTab header={
                            <span className="flex align-items-center gap-2 w-full">Unidades ociosas ({idleUnits.length})</span>
                        }>
                            <DataTable className={'idle-units-table'} value={idleUnits}>
                                <Column field="UNIDAD" header="ID" sortable/>
                                <Column field="FECHA" header="Fecha ultima bitacora" sortable/>
                                <Column field="MARCA" header="Tipo" sortable/>
                                <Column field="POSITION.ti" header="Última actualización" sortable/>
                                <Column headerStyle={{ width: '5rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} body={actionBodyTemplate} />
                            </DataTable>
                        </AccordionTab>
                    </Accordion>
                </div>
            </div>
            <DataTable value={units} expandedRows={expandedRows}
                       onRowToggle={(e) => setExpandedRows(e.data)}
                       rowExpansionTemplate={rowExpansionTemplate} dataKey="id" className={'table-padding'}>
                <Column expander style={{width: '3em'}}/>
                <Column header="Grupo" body={headerTemplate}/>
                <Column body={headerDetail}/>
            </DataTable>
        </div>
    );

}

export default Units
